<template>
    <div v-if="!profile!.editMode" class="profile-cta">
        <VJoyButton
            class="profile-cta-project"
            data-testid="project-proposal-cta"
            variant="main"
            :loading="loading"
            @click="redirectToProjectProposal"
        >
            {{ t('show.contactme.button.label') }}
        </VJoyButton>
        <small v-if="displaySubtitle" class="profile-cta-subtitle">{{ t('profile.project.submission.title', {0: profile!.firstname}) }}</small>
    </div>
    <div v-else class="profile-cta">
        <div class="profile-cta-project"></div>
    </div>
</template>

<script setup lang="ts">
    import {useRoute} from '@typed-router';
    import {storeToRefs} from 'pinia';
    import {ref, useTranslation} from '#imports';
    import {safelyNavigateTo} from '@malt/utils';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {useProfileStore} from '~/store/profileStore';

    type Props = {
        displaySubtitle: boolean;
    };
    defineProps<Props>();

    const {t} = useTranslation();
    const loading = ref(false);
    const route = useRoute();

    const {profile} = storeToRefs(useProfileStore());

    function redirectToProjectProposal() {
        loading.value = true;

        return safelyNavigateTo(
            {
                path: '/client/briefs/proposal',
                query: {
                    searchId: route?.query?.searchid,
                    profileViewId: profile.value!.profileViewId,
                    sourceComponent: route?.query?.sourceComponent,
                    entryPoint: 'profile_page',
                },
            },
            {externalToThisApp: true},
        );
    }
</script>

<style lang="scss" scoped>
    .profile-cta {
        width: 200px;
        height: 100%;

        display: flex;
        flex-direction: column;
        align-items: flex-start;

        &-project {
            margin-bottom: var(--joy-core-spacing-2);
            width: 100%;
        }

        &-subtitle {
            margin-right: auto;
            margin-left: auto;
        }
    }
</style>
